import { j as r } from "./jsx-runtime-CZlWR0BA.js";
import { memo as P, forwardRef as z } from "react";
import { I as M } from "./icon-DA-Zqp8s.js";
import { C as t, H as n } from "./styled-components.browser.esm-CdvvWRMU.js";
const I = {
  lg: t`
    padding: 20px 32px;
    height: ${(e) => e.theme.spacingInlineLg};
  `,
  md: t`
    padding: 16px 32px;
    height: ${(e) => e.theme.spacingInlineMd};
    font-size: ${(e) => e.theme.fontSizeXxxs};
  `,
  sm: t`
    padding: 14px 16px;
    height: ${(e) => e.theme.spacingInlineSm};
    font-size: ${(e) => e.theme.fontSizeNano};
  `,
  xs: t`
    padding: 9px 8px;
    height: ${(e) => e.theme.spacingInlineXs};
    font-size: ${(e) => e.theme.fontSizeNano};
  `
}, j = {
  lg: t`
    padding: ${(e) => e.theme.spacingStackXxxsRem};
    height: ${(e) => e.theme.spacingInlineLg};
    width: ${(e) => e.theme.spacingInlineLg};
  `,
  md: t`
    padding: ${(e) => e.theme.spacingStackMicroRem};
    height: ${(e) => e.theme.spacingInlineMd};
    width: ${(e) => e.theme.spacingInlineMd};
    font-size: ${(e) => e.theme.fontSizeXxxs};
  `,
  sm: t`
    padding: ${(e) => e.theme.spacingStackMicroRem};
    height: ${(e) => e.theme.spacingInlineSm};
    width: ${(e) => e.theme.spacingInlineSm};
    font-size: ${(e) => e.theme.fontSizeNano};
  `,
  xs: t`
    padding: ${(e) => e.theme.spacingStackNanoRem};
    height: ${(e) => e.theme.spacingInlineXs};
    width: ${(e) => e.theme.spacingInlineXs};
    font-size: ${(e) => e.theme.fontSizeNano};
  `
}, B = {
  primary: t`
    background-color: ${(e) => e.theme.brandPrimaryMedium};
    box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryMedium};
    color: ${(e) => e.theme.colorNeutralSnow};

    &:hover {
      background-color: ${(e) => e.theme.brandPrimaryDark};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryDark};
      color: ${(e) => e.theme.colorNeutralSnow};
    }

    &:active {
      background-color: ${(e) => e.theme.brandPrimaryDarkest};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryDarkest};
      color: ${(e) => e.theme.colorNeutralSnow};
    }

    &:disabled,
    &[disabled] {
      background-color: ${(e) => e.theme.colorDisabledLight};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.colorDisabledLight};
      color: ${(e) => e.theme.colorDisabledDark};
    }
  `,
  secondary: t`
    background-color: ${(e) => e.theme.brandPrimaryLightest};
    box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryMedium};
    color: ${(e) => e.theme.brandPrimaryMedium};

    &:hover {
      background-color: ${(e) => e.theme.brandPrimaryLightest};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryDark};
      color: ${(e) => e.theme.brandPrimaryDark};
    }

    &:active {
      background-color: ${(e) => e.theme.brandPrimaryLight};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryDarkest};
      color: ${(e) => e.theme.brandPrimaryDarkest};
    }

    &:disabled,
    &[disabled] {
      background-color: ${(e) => e.theme.colorDisabledLight};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.colorDisabledMedium};
      color: ${(e) => e.theme.colorDisabledDark};
    }
  `,
  tertiary: t`
    background-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
    color: ${(e) => e.theme.brandPrimaryMedium};

    &:hover {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryMedium};
      color: ${(e) => e.theme.brandPrimaryMedium};
      > .text {
        opacity: ${(e) => e.theme.opacitySemiOpaque};
      }
    }

    &:active {
      background-color: ${(e) => e.theme.brandPrimaryDark};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandPrimaryDark};
      color: ${(e) => e.theme.brandPrimaryLightest};
    }

    &:disabled,
    &[disabled] {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.colorDisabledDark};
      > .text {
        opacity: ${(e) => e.theme.opacityIntense};
      }
    }
  `,
  "tertiary-inverse": t`
    background-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
    color: ${(e) => e.theme.colorNeutralSnow};

    &:hover {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.colorNeutralSnow};
      color: ${(e) => e.theme.colorNeutralSnow};
      > .text {
        opacity: ${(e) => e.theme.opacitySemiOpaque};
      }
    }

    &:active {
      background-color: ${(e) => e.theme.colorNeutralSnow};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.colorNeutralSnow};
      color: ${(e) => e.theme.colorDisabledDark};
    }

    &:disabled,
    &[disabled] {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.colorDisabledDark};
      > .text {
        opacity: ${(e) => e.theme.opacitySemiOpaque};
      }
    }
  `,
  highlight: t`
    background-color: ${(e) => e.theme.brandHighlightMedium};
    box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandHighlightMedium};
    color: ${(e) => e.theme.colorNeutralSnow};

    &:hover {
      background-color: ${(e) => e.theme.brandHighlightDark};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandHighlightDark};
      color: ${(e) => e.theme.colorNeutralSnow};
      > .text {
        opacity: ${(e) => e.theme.opacitySemiOpaque};
      }
    }

    &:active {
      background-color: ${(e) => e.theme.brandHighlightDarkest};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.brandHighlightDarkest};
      color: ${(e) => e.theme.colorNeutralSnow};
    }

    &:disabled,
    &[disabled] {
      background-color: ${(e) => e.theme.colorDisabledLight};
      box-shadow: inset 0 0 0 1px ${(e) => e.theme.colorDisabledLight};
      color: ${(e) => e.theme.colorDisabledDark};
      > .text {
        opacity: ${(e) => e.theme.opacityIntense};
      }
    }
  `,
  "highlight-inverse": t`
    background-color: ${(e) => e.theme.colorNeutralSnow};
    box-shadow: inset 0 0 0 1px transparent;
    color: ${(e) => e.theme.brandHighlightMedium};

    &:hover {
      background-color: ${(e) => e.theme.colorNeutralSnow};
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.brandHighlightDark};
      > .text {
        opacity: ${(e) => e.theme.opacitySemiOpaque};
      }
    }

    &:active {
      background-color: ${(e) => e.theme.colorNeutralSnow};
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.brandHighlightDarkest};
    }

    &:disabled,
    &[disabled] {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.colorDisabledMedium};
      ::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        width: 100%;
        background-color: ${(e) => e.theme.colorDisabledLight};
        opacity: ${(e) => e.theme.opacityIntense};
        border-radius: ${(e) => e.isIconOnly ? e.theme.borderRadiusCircular : e.theme.borderRadiusMd};
      }
    }
  `,
  neutral: t`
    background-color: transparent;
    color: ${(e) => e.theme.colorNeutralDarkest};

    &:disabled,
    &[disabled] {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.colorDisabledDark};
    }
  `,
  // TODO: review padding width and height of interactive, interactive-inverse
  interactive: t`
    letter-spacing: 0;
    background-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
    color: ${(e) => e.theme.brandPrimaryMedium};
    border-radius: ${(e) => e.theme.borderRadiusCircular};

    &:hover {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.brandPrimaryDark};
    }

    &:active {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.brandPrimaryDarkest};
    }

    &:disabled,
    &[disabled] {
      background-color: transparent;
      box-shadow: inset 0 0 0 1px transparent;
      color: ${(e) => e.theme.colorDisabledDark};
    }
  `,
  "interactive-inverse": t`
    letter-spacing: 0;
    background-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
    color: ${(e) => e.theme.colorNeutralSnow};
    border-radius: ${(e) => e.theme.borderRadiusCircular};

    &:hover {
      opacity: ${(e) => e.theme.opacityIntense};
    }

    &:active {
      color: ${(e) => e.theme.colorDisabledMedium};
    }

    &:disabled,
    &[disabled] {
      color: ${(e) => e.theme.colorNeutralSnow};
    }
  `
}, H = {
  lg: "32px",
  md: "24px"
}, L = n.span`
  height: 1px;
  overflow: hidden;
  position: absolute;
  width: 1px;
  clip: rect(1px, 1px, 1px, 1px);
  margin-top: -1px;
`, x = n.div`
  position: absolute;
  display: inline-block;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
`, R = ({ size: e = "md" }) => {
  const o = H[e];
  return /* @__PURE__ */ r.jsxs(x, { role: "alert", "aria-label": "cargando", "aria-live": "polite", children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: o,
        height: o,
        viewBox: "0 0 50 50",
        xmlSpace: "preserve",
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z",
            children: /* @__PURE__ */ r.jsx(
              "animateTransform",
              {
                attributeType: "xml",
                attributeName: "transform",
                type: "rotate",
                from: "0 25 25",
                to: "360 25 25",
                dur: "0.6s",
                repeatCount: "indefinite"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(L, { children: "cargando" })
  ] });
}, O = (e) => {
  const { size: o } = e;
  return I[o];
}, X = (e) => {
  const { size: o } = e;
  return j[o];
}, C = (e) => {
  const { variant: o } = e;
  return B[o];
}, a = n.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  justify-content: center;
`, q = n.button`
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: transparent;
  display: inline-flex;
  letter-spacing: 0.00255rem;
  text-align: center;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  border: 0;
  font-family: ${(e) => e.theme.fontFamilySemibold};
  font-size: ${(e) => e.theme.fontSizeXxxs};
  border-radius: ${(e) => e.theme.borderRadiusMd};
  line-height: ${(e) => e.theme.lineHeightTight};
  outline: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:focus,
  &:active {
    outline: none;
  }

  &:disabled,
  &[disabled] {
    ${({ isLoading: e }) => e ? t`
          pointer-events: none;
          cursor: not-allowed;

          > ${a} {
            opacity: 0;
          }

          > ${x} {
            opacity: 0.32;
          }
        ` : t`
        pointer-events: none;
        > ${a} {
          opacity: 0.32;
        }
      `}
  }

  ${(e) => e.isBlock ? t`
      display flex;
      width: 100%;
    ` : t`
          width: fit-content;
        `}

  ${(e) => e.isLoading && t`
      pointer-events: none;
      cursor: not-allowed;

      > ${a} {
        opacity: 0;
      }
    `}

  ${O}
  ${C}

  ${(e) => e.isIconOnly && t`
      letter-spacing: 0;
      border-radius: ${(o) => o.theme.borderRadiusCircular};
      ${X}
    `}

  width: ${(e) => e.width};
`, T = (e) => e === "lg" ? "md" : e === "xs" ? "sm" : e, $ = z(
  ({
    children: e,
    disabled: o,
    iconName: h,
    iconWeight: w,
    isLoading: i,
    isBlock: k,
    hasIcon: m,
    variant: y = "primary",
    size: s = "md",
    type: f = "button",
    isIconOnly: p,
    href: b,
    target: l,
    onClick: c,
    width: D,
    ...S
  }, v) => {
    const d = h ? /* @__PURE__ */ r.jsx(M, { name: h, weight: w, size: T(s), role: "img", "aria-label": "icon" }) : null, g = b || l, N = (u) => {
      if (o || i) {
        u.preventDefault();
        return;
      }
      c == null || c(u);
    };
    return /* @__PURE__ */ r.jsxs(
      q,
      {
        ref: v,
        disabled: o,
        size: s,
        variant: y,
        isBlock: k,
        isIconOnly: p,
        type: f,
        href: b,
        width: D,
        target: l,
        onClick: N,
        isLoading: i,
        as: g ? "a" : "button",
        ...g && { role: "button", rel: l === "_blank" ? "noopener noreferrer" : void 0 },
        ...S,
        children: [
          i && /* @__PURE__ */ r.jsx(R, { size: s === "lg" ? "lg" : "md" }),
          /* @__PURE__ */ r.jsx(a, { className: "text", children: p ? d : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
            m === "left" && d,
            e,
            m === "right" && d
          ] }) })
        ]
      }
    );
  }
);
$.displayName = "Button";
const A = P($);
export {
  A as B
};
